import { createContext } from "react";
import { AssociationContextType } from "./interface";

export const AssociationContext = createContext<AssociationContextType>({
  associations: [],
  getAssociations: () => Promise.resolve(),
  statistics: null,
  setStatistics: () => {},
});
